module.exports = __webpack_public_path__ + "static/media/avatar.d8f21be5.png";